export class Response {
  constructor(
    public data: any = null,
    public message: string = "",
    public status: string = "",
    public statusCode: number = 200
  ) {}
}
